import * as React from 'react';
import Head from '~/common/layout/Head';

export default(props) => {
  const { onSearch, onCreate } = props;

  return (
    <Head headTitle="Organizations">
      <div className="input--search">
        <a onClick={onSearch} href="javascript:void(null)" className="input__icon input--search__btn">
          <span className="i i-search"></span>
        </a>
        <input type="text" placeholder="Search"/>
      </div>

      <a onClick={onCreate} href="javascript:void(null)" className="btn btn--secn btn--lg">Create</a>
    </Head>
  );
};
